import { Component, Input } from '@angular/core';
import { CampanhaROIChart } from '../campanha-roi-chart';

@Component({
    selector: 'sgt-campanha-roi-chart-table',
    templateUrl: './campanha-roi-chart-table.component.html',
    styleUrls: ['./campanha-roi-chart-table.component.less']
})
export class CampanhaROIChartTableComponent {
    @Input() chart: CampanhaROIChart;
    @Input() isVisualizacaoCampanhas = false;
    @Input() isVisualizacaoPacotes = false;
    @Input() isLoading: boolean;
    @Input() isEmpty: boolean;
}
